import LayoutSetPublicProfessional from 'components/ui/layout-set/public/layout-set-public-professional';

import LayoutSetPublicRegisterInstance from 'components/ui/layout-set/public/layout-set-public-register-instance';

import LayoutSetPublicThankYou from 'components/ui/layout-set/public/layout-set-public-thank-you';

import Page403 from 'components/pages/professional/errors/page-403';
import Page404 from 'components/pages/professional/errors/page-404';

import PageProfessionalLogin from 'components/pages/professional/public/login/page-professional-login';
import PageProfessionalLogout from 'components/pages/professional/public/logout/page-professional-logout';

import PageProfessionalForgotPassword from 'components/pages/professional/public/forgot-password/page-professional-forgot-password';
import PageProfessionalResetPassword from 'components/pages/professional/public/reset-password/page-professional-reset-password';

import PageJoinInstance from 'components/pages/professional/public/join-instance/page-join-instance';

import PageProfessionalVerifyEmail from 'components/pages/professional/public/verify-email/page-professional-verify-email';

import PageCreateInstance from 'components/pages/professional/public/create-instance/page-create-instance';

import PageCreateInstanceStepOne from 'components/pages/professional/public/create-instance/step-1/page-create-instance-step-one';
import PageCreateInstanceStepTwo from 'components/pages/professional/public/create-instance/step-2/page-create-instance-step-two';
import PageCreateInstanceStepThree from 'components/pages/professional/public/create-instance/step-3/page-create-instance-step-three';

import PageCreateInstanceThankYou from 'components/pages/professional/public/create-instance-thank-you/page-create-instance-thank-you';

import PageResendCompletionToken from 'components/pages/shared/resend-completion-token/page-resend-completion-token';

export default [
  {
    path: '/professional',
    component: LayoutSetPublicProfessional,
    children: [
      {
        path: '403',
        name: 'professional-forbidden',
        component: Page403,
        meta: {
          auth: true,
        },
      },
      {
        path: '404',
        name: 'professional-404',
        component: Page404,
        meta: {
          auth: true,
        },
      },
      {
        path: 'login',
        name: 'professional-login',
        component: PageProfessionalLogin,
        props: route => ({
          redirect: route.query.redirect,
        }),
        meta: {
          auth: false,
        },
      }, // end ~ login
      {
        path: 'logout',
        name: 'professional-logout',
        component: PageProfessionalLogout,
      }, // end ~ login
      {
        path: 'forgot-password',
        name: 'professional-forgot-password',
        component: PageProfessionalForgotPassword,
        meta: {
          auth: false,
        },
      },
      {
        path: 'reset-password',
        name: 'professional-reset-password',
        component: PageProfessionalResetPassword,
        props: route => ({
          token: route.query.token,
        }),
      },
      {
        path: 'verify-email',
        name: 'professional-verify-email',
        component: PageProfessionalVerifyEmail,
        props: route => ({
          token: route.query.token,
        }),
      },
      {
        path: 'join-instance',
        name: 'professional-join-instance',
        component: PageJoinInstance,
        meta: { auth: false },
        props: route => ({
          token: route.query.token,
        }),
      },
      {
        path: 'resend-completion-token',
        name: 'professional-resend-completion-token',
        component: PageResendCompletionToken,
        meta: { auth: false },
      },
    ],
  },
  {
    path: '/professional',
    component: LayoutSetPublicRegisterInstance,
    children: [
      {
        path: 'create-instance',
        component: PageCreateInstance,
        meta: {
          auth: false,
        },
        children: [
          {
            path: '',
            name: 'create-instance-professional-step-one',
            component: PageCreateInstanceStepOne,
            props: route => ({
              lang: route.query.lang,
              email: route.query.email,
              meta: {
                navigation: {
                  success: 'create-instance-professional-step-two',
                },
              },
            }),
            meta: {
              auth: false,
            },
          },
          {
            path: 'step-two',
            name: 'create-instance-professional-step-two',
            component: PageCreateInstanceStepTwo,
            props: {
              meta: {
                navigation: {
                  previous: 'create-instance-professional-step-one',
                  success: 'create-instance-professional-checkout',
                },
              },
            },
            meta: {
              auth: false,
            },
          },
          {
            path: 'checkout',
            name: 'create-instance-professional-checkout',
            component: PageCreateInstanceStepThree,
            props: {
              meta: {
                navigation: {
                  previous: 'create-instance-professional-step-two',
                  success: 'create-instance-professional-thank-you',
                },
              },
            },
            meta: {
              auth: false,
            },
          },
        ],
      }, // end ~ create instance
    ],
  },
  {
    path: '/professional',
    component: LayoutSetPublicThankYou,
    props: route => ({
      token: route.query.token,
    }),
    children: [
      {
        path: 'thank-you',
        name: 'create-instance-professional-thank-you',
        component: PageCreateInstanceThankYou,
        props: route => ({
          token: route.query.token,
          meta: {
            navigation: {},
          },
        }),
        meta: {
          auth: false,
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/professional/base/index.js